var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","small":"","text":"","loading":_vm.loading},on:{"click":function($event){return _vm.restore(_vm.item)}}},[_vm._v("Restore")])
}
var staticRenderFns = []

export { render, staticRenderFns }